import { render, staticRenderFns } from "./release-notes.vue?vue&type=template&id=304ffb38"
import script from "./release-notes.vue?vue&type=script&lang=ts"
export * from "./release-notes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports